import { render, staticRenderFns } from "./CloudColorPicker.vue?vue&type=template&id=115b836a&"
import script from "./CloudColorPicker.vue?vue&type=script&lang=js&"
export * from "./CloudColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/veevoeders-biervliet/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('115b836a')) {
      api.createRecord('115b836a', component.options)
    } else {
      api.reload('115b836a', component.options)
    }
    module.hot.accept("./CloudColorPicker.vue?vue&type=template&id=115b836a&", function () {
      api.rerender('115b836a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/CloudColorPicker.vue"
export default component.exports